<script lang="ts">
    import type { SvelteComponent } from "svelte";
    export let type: 'submit'|'button' = 'button';
    export let disabled: boolean = false;
    export let label: string;
    export let onclick: (e: MouseEvent) => void;

    export let appearance: 'filled'|'outline'|'text' = 'filled';
    export let color: 'default'|'primary'|'secondary'|'success' = 'default';
    export let block: boolean = false;
    export let elevation: 'elevation-none'|'elevation-1'|'elevation-2'|'elevation-3'|'elevation-4'|'elevation-5' = 'elevation-none';
    export let icon: SvelteComponent|any|undefined = undefined;
</script>

<button {type} class="Button Button--{appearance} Button--{color} {elevation}" class:Button--block={block} on:click={onclick} {disabled}>
    {#if icon}
        <svelte:component this={icon} width="24px" height="24px" color="#fff" />
    {/if}
    {label}
</button>

<style type="text/scss">
    @import '../../scss/config.scss';
@import '../../scss/mixin/rippleButton.scss';

.Button {
  border: 0;
  cursor: pointer;
  margin: 0;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  justify-content: center;
  text-decoration: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  padding: 6px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.75;
  border-radius: 4px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,0.2), 0 2px 2px 0px rgba(0,0,0,0.14), 0 1px 5px 0px rgba(0,0,0,0.12);
  &:hover {
    box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0px rgba(0,0,0,0.14), 0 1px 10px 0px rgba(0,0,0,0.12);
  }
  &:active {
    box-shadow: 0 5px 5px -3px rgba(0,0,0,0.2), 0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12);
  }
  @include rippleButton($color-light-grey);

  :global(svg) {
    margin-right: 5px;
  }

  &--primary {
    color: $color-white;
    @include rippleButton($color-primary);
  }

  &--secondary {
    color: $color-white;
    @include rippleButton($color-secondary);
  }

  &--success {
    color: $color-white;
    @include rippleButton($color-success);
  }

  &.elevation-none {
    box-shadow: none;
    &:hover, &:active {
      box-shadow: none;
    }
  }

  &--text {
    background: transparent;
    box-shadow: none;
    color: fade_out($color-base, 0.2);
    padding-right: 0;
    padding-left: 0;
    &:hover {
      background: transparent;
      box-shadow: none;
      color: $color-base;
    }
    &:active {
      background: transparent;
      box-shadow: none;
      color: $color-base;
    }
  }

  &--block {
    display: block;
  }
}
</style>
